import { render } from "./PermissionsAddPage.vue?vue&type=template&id=44efd7ce&ts=true"
import script from "./PermissionsAddPage.vue?vue&type=script&lang=ts"
export * from "./PermissionsAddPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__